import React , { Component } from "react";
import {Modal} from "react-bootstrap";
import ButtonPrimary from "../ButtonPrimary";


class BottomSheetConfirm extends Component {

    constructor(props) {
        super(props);
    }
    componentDidMount() {

    }

    handleClick = (type , data) => e => {
        this.props.action(type , data)
    }

    render() {
        return (
            <Modal className='bottom-sheet fade in' show={this.props.show} onHide={this.props.onHide}>
                <Modal.Body>
                    <div className='d-flex justify-content-center pt-10 pb-10'>
                        <div className='bottom-sheet-close-line btn p-0 ' />
                    </div>

                    <div className='mobile-h5 cl-black mt-20'>
                        { this.props.title }
                    </div>
                    <div className='mobile-subtitle-regular cl-subtitle mt-custom-4'>
                        { this.props.body }
                    </div>

                    <div className='row align-items-center mt-32'>
                        <div className='col-6'>
                            <div onClick={this.handleClick('negative',this.props.data)}>
                                <ButtonPrimary text='انصراف'
                                               mode='light-mode' />
                            </div>
                        </div>
                        <div className='col-6'>
                            <div onClick={this.handleClick('positive',this.props.data)}>
                                <ButtonPrimary text={this.props.btnText}
                                               mode='dark-mode'
                                               isLoading={this.props.isLoading} />
                            </div>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        );
    }
}

export default BottomSheetConfirm